import React, { Component } from 'react';
import $ from 'jquery';
import Vas from '../Vas';
import { ExtendedButton,TextField,Icon } from 'component-lib';
import { CheckEmail } from 'utils-lib';
import { RequestAjaxClass, AccountsModel } from 'models-lib';

class ResetPassword  extends Component {

    constructor(props){
      super(props);
      this.state={};
      this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
      this.AccountsModel = new AccountsModel([this], null, this.Request);

      //Hier die Angaben zur Vertragsanlage löschen, da der Dokumentenupload ebenfalls erfolgreich war
      localStorage.removeItem("CustomerId");
      localStorage.removeItem("ContractNUmber");
      localStorage.removeItem("ExecutingForm");
    }

    componentDidMount(){
      this.Request.setAuth(false);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setErrorHandler(()=>{
        $("#LoadingIcon").removeClass().addClass('hide');
      })
    }

    Update(observer){
      this.setState({},()=>{
        if(observer === "ResetAccounts"){
          $("#LoadingIcon").removeClass().addClass('hide');
          Vas.GetView('ResetPassworsSuccess');
        }
      })
    }

    ResetPassword(){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');

        this.AccountsModel.AccountReset($('#EMail').val());
    }

    Close(){
        Vas.GetView("Login",null,false);
    }

    checkEmail(){
        if (CheckEmail.Check(document.getElementById('EMail').value) === true){
            this.refs.IconEmail.setState({ Name:"Done",Color:"green" });
            this.refs.btoChange.setState({ usable:true });
        } else {
            this.refs.IconEmail.setState({ Name:"Warning",Color:"red" });
            this.refs.btoChange.setState({ usable:false });
        }
    }

    render()
    {
       return (
       <div className={"form resetPasswordForm"} style={{width:'400px'}}>
         <div>
           <table>
             <thead>
               <tr>
                 <th colSpan={2}>
                    <div id={"ResetPasswordHeadline"}>
                      {Vas.Resources.Labels["ResetPassword"]}
                    </div>
                 </th>
                 <th>
                    <div
                      id={"LoadingIcon"}
                      className={'hide'}></div>
                 </th>
               </tr>
             </thead>
             <tbody>
               <tr>
                 <td colSpan={2}>
                   <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["PasswordForgottenText1"]}</div><br />
                 </td>
               </tr>
               <tr>
                 <td colSpan={2}>
                   <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["PasswordForgottenText2"]}</div><br />
                 </td>
               </tr>
               <tr>
                 <td colSpan={2}>
                   <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["PasswordForgottenText3"]}</div><br />
                 </td>
               </tr>
               <tr>
                 <td colSpan={2}>
                   <TextField
                     AppURL={Vas.ApplicationUrl}
                     Id="EMail"
                     ref={"EMail"}
                     name="EMail"
                     Editable={true}
                     IsRequired={true}
                     Label={Vas.Resources.Labels["E-Mail-Address"]}
                     Width={280}
                     OnChange={()=>{ this.checkEmail();}} />
                   <Icon
                     ref={"IconEmail"}
                     Name={"Warning"}
                     Size={24}
                     Color={"red"}
                     Align={"left"} />
                   <br />
                 </td>
               </tr>
               <tr>
                 <td>
                   <div>
                   <ExtendedButton
                     Id={"PasswordResetButton"}
                     Usable={false}
                     ref={"btoChange"}
                     Text={Vas.Resources.Labels["ResetPassword"]}
                     OnClick={()=>{ this.ResetPassword();}}
                     style={{ margin: 25 }}
                     Width={165} 
                     Float={"left"}/>

                   <ExtendedButton
                     Id={"PasswordResetButtonBack"}
                     Usable={true}
                     Text={Vas.Resources.Labels["Cancel"]}
                     OnClick={()=>{ this.Close();}}
                     style={{ margin: 25 }}
                     Width={165}
                     Float={"right"} />
                     </div>
                 </td>
               </tr>
             </tbody>
           </table>
         </div>
       </div>
       );
    }
}
export default ResetPassword;
